import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [
    {
        id: 1,
        label: 'MENUITEMS.MENU.TEXT',
        isTitle: true
    },
    {
        id: 3,
        isLayout: true
    },
    {
        id: 2,
        label: 'MENUITEMS.DASHBOARDS.TEXT',
        icon: 'uil-home-alt',
        link: '/',
    },
    {
        id: 6,
        label: 'Pattern Management',
        icon: 'uil-bolt-alt',
        subItems: [
   
            {
                id: 78,
                label: 'View',
                link: '/pattern-management/all-patterns',
                parentId: 3
            },
            // {
            //     id: 79,
            //     label: 'Add Size',
            //     link: '/pattern-management/add-size',
            //     parentId: 3
            // }
        ]
    },
    {
        id: 7,
        label: 'Po Management',
        icon: 'uil-shutter-alt',
        subItems: [
            {
                id: 78,
                label: 'View VL',
                link: '/po-details/view-all-vl',
                parentId: 7
            },
        ]
    },
];

